module.exports = __webpack_public_path__ + "dist/media/fingerprint-artwork-slide.2e008477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/fingerprint-artwork-slide.png
// module id = 366
// module chunks = 0